import React from 'react';

export default class AppService extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonStyle: 'link',
      lang: undefined,
      welcome: undefined,
      need: undefined,
      create: undefined,
      userid: undefined,
      admin: undefined,
      remember: undefined,
      passwordLabel: undefined,
      signin: undefined,
      forgot: undefined,
      forgotPwd: undefined,
      clickHere: undefined,
      forgotUid: undefined,
      showHide: false,
      next: undefined,
      userAlert: undefined,
      username: undefined,
      titleChange: undefined,
      welcomeBack: undefined,
      privacy: undefined,
      legal: undefined,
      userIdPopoverMsg: undefined,
      confirmPasswordLabel: undefined,
      submit: undefined,
      sendcode: undefined,
      verificationcodeLabel: undefined,
      submitcodeLabel: undefined,
      resendcodelink: undefined,
      termsConditionsTitle: undefined,
      accept: undefined,
      cancel: undefined,
      showLoginForm: true,
      showCreatePassword: false,
      showDeliveryMethod: false,
      showDeliveryMethodFF: false,
      showTermCondition: false,
      showVerificationCode: false,
      showAnswerYourQns: false,
      createPassword: undefined,
      showcreateSecurityQnA: undefined,
      verificationcodeTitle: undefined,
      deliveryMethodTitle: undefined,
      title: undefined,
      errorMessage: undefined,
      welcomeBackFlag: false,
      deliveryMediumType: '',
      showLocale: true,
      privacylocale: '',
      legallocale: '',
      presentchal: '',
      adpDisabledUser: undefined,
      adpSuspendedUser: undefined,
      arcotIdOrqnaDisabled: undefined,
      aidLocked:undefined,
      userIdCheck: undefined,
      forgotUIDLink: undefined,
      notAuthorized: undefined,
      invalidUserId: undefined,
      invalidEmail: undefined,
      signInNewBrowser: undefined,
      genericError: undefined,
      deliverypageexist: false,
      passwordStrengthHelperText: undefined,
      createPasswordLable: undefined,
      frgtFlow: false,
      QandATitle: undefined,
      StepQandATitle: undefined,
      showOtpDevices: false,
      showOtpVerificationCode: false,
      stepupOtpDevices: '',
      successAlertMessage: undefined,
      verificationCodeHelpMessage: undefined,
      resendAcCodeMessage: undefined,
      showChallengeQna: false,
      createSequrityQnaTitle: undefined,
      challengeModeHigh: false,
      stepupSelectQnaOnly: undefined,
      deliveryOtpByEmailOnly: undefined,
      showSessionExpired: false,
      sessionTimedOutMessage: undefined,
      sessionTimedOutTitle: undefined,
      continueButton: '',
      answerLable: '',
      question3Lable: '',
      question2Lable: '',
      question1Lable: '',
      passwordStrengthIndLetter: '',
      passwordStrengthIndNumber: '',
      passwordStrengthIndChars: '',
      noQuestionBlank: '',
      noAnswerBlank: '',
      noAnswerSame: '',
      closeBrowserTitle: '',
      closeBrowserMessage: '',
      showCloseBrowser:false,
      showTcModel:true,
      select:'',
      isShowLocale:false
    };
  }

  localeService(data, valueField) {
    const language = data;
    this.setState({
      lang: valueField.language,
      welcome: language['welcome.title'],
      need: language['signin.need'],
      create: language['signin.createAccount'],
      userid: language['signin.userid'],
      admin: language['signin.admin'],
      remember: language['signin.remember'],
      passwordLabel: language['signin.password'],
      signin: language['signin.signin'],
      forgot: language['signin.forgot'],
      forgotPwd: language['signin.forgotPwd'],
      clickHere: language['signin.clickHere'],
      forgotUid: language['signin.forgotUid'],
      empsignin: language['sigin.empSignIn'],
      next: language['sigin.next'],
      userAlert: undefined,
      username: undefined,
      titleChange: undefined,
      welcomeBack: language['sigin.welBack'],
      privacy: language['footer.privacy'],
      legal: language['footer.legal'],
      userIdPopoverMsg: language['msg.userIdPopoverMsg'],
      confirmPasswordLabel: language['create.confirmPasswordLabel'],
      submit: language['signin.submit'],
      sendcode: language['send.verificationcode'],
      verificationcodeLabel: language['enetr.verificationLabel'],
      submitcodeLabel: language['submit.code'],
      resendcodelink: language['resend.code'],
      termsConditionsTitle: language['terms.conditions'],
      accept: language['terms.accept'],
      cancel: language['terms.cancel'],
      createPassword: language['create.password'],
      verificationcodeTitle: language['enter.verificationTitle'],
      QandATitle: language['enter.answeryourquestion'],
      StepQandATitle: language['enter.stepupAnsweryourquestion'],
      deliveryMethodTitle: language['Deliverymethod.label'],
      title: language['signin.admin'],
      copyright: language['footer.company'],
      adpDisabledUser: language['challenge.adpDisabledUser'],
      adpSuspendedUser: language['challenge.adpSuspendedUser'],
      aidLocked: language['challenge.aidLocked'],
      arcotIdOrqnaDisabled: language['challenge.arcotIdOrqnaDisabled'],
      userIdCheck: language['sigin.userIdCheck'],
      passwordCheck: language['signin.passwordCheck'],
      notAuthorized: language['challenge.notAuthorized'],
      invalidUserId: language['challenge.invalidUserId'],
      invalidEmail: language['challenge.invalidEmail'],
      genericError: language['challenge.ARCOT_GENERIC_ERROR'],
      passwordStrengthHelperText: language['password.strengthHelper'],
      createPasswordLable: language['create.PasswordLabel'],
      sentSuccess: language['mail.sentSuccess'],
      passwordSuccess: language['change.password_success'],
      verificationCodeHelpMessage: language['verificationCode.help.message'],
      resendAcCodeMessage: language['resend.activationCode.message'],
      stepupSelectQnaOnly: language['stepup.selectQnaOnly'],
      sessionTimedOutMessage: language['session.sessionTimedOutMessage'],
      sessionTimedOutTitle: language['session.sessionTimedOutTitle'],
      signInNewBrowser: language['session.tooManyTries'],
      createSequrityQnaTitle: language['title.createQna'],
      continueButton: language['button.label.continue'],
      answerLable: language['label.answer'],
      question3Lable: language['label.question3'],
      question2Lable: language['label.question2'],
      question1Lable: language['label.question1'],
      passwordStrengthIndLetter: language['password.strength.ind.letter'],
      passwordStrengthIndNumber: language['password.strength.ind.number'],
      passwordStrengthIndChars: language['password.strength.ind.chars'],
      fypPwdSuccess: language['fyp.passwordSuccessMsg'],
      fypResendMsg: language['fyp.fypResendMsg'],
      noQuestionBlank: language['qna.noquestionblank.message'],
      noAnswerBlank: language['qna.noanswerblank.message'],
      noAnswerSame: language['qna.noanswersame.message'],
      closeBrowserTitle: language['title.closeBrowser'],
      closeBrowserMessage: language['closeBrowser.message'],
      select:language['select.label'],
      userSuspended:language['user.suspended']
    });
  }

  showCreatePasswordFF() {
    this.setState({
      showCreatePasswordFF: true,
      showLoginForm: false,
      showAnswerYourQns: false,
      title: this.state.createPassword,
      showVerificationCodeFF: false,
      showDeliveryMethodFF: false,
      showDeliveryMethod: false,
      showLocale: true
    });
  }

  showVerificationCodeFF(value) {
    this.setState({
      showAnswerYourQns: false,
      showVerificationCodeFF: true,
      showDeliveryMethodFF: false,
      showDeliveryMethod: false,
      showCreatePassword: false,
      showLoginForm: false,
      title: this.state.verificationcodeTitle,
      resendcodeValue: value,
      showLocale: true
    });
  }
  showAnswerYourQnsFF() {
    this.setState({
      showAnswerYourQns: true,
      showVerificationCodeFF: false,
      showDeliveryMethodFF: false,
      showDeliveryMethod: false,
      showCreatePassword: false,
      showLoginForm: false,
      title: this.state.QandATitle,
      showLocale: true
    });
  }

  showDeliveryMethodFF() {
    this.setState({
      showDeliveryMethodFF: true,
      showVerificationCode: false,
      showCreatePassword: false,
      showVerificationCodeFF: false,
      showLoginForm: false,
      showAnswerYourQns: false,
      title: this.state.deliveryMethodTitle,
      showLocale: true
    });
  }

  showLoginForm() {
    this.setState({
      showDeliveryMethodFF: false,
      showVerificationCode: false,
      showCreatePassword: false,
      showVerificationCodeFF: false,
      showLoginForm: true,
      showAnswerYourQns: false,
      showCreatePasswordFF: false,
      fypNewPassword: true,
      showHide: false,
      showLocale: true,
      title: this.state.admin,
      username: this.state.username

    });
  }
  showEnrollLoginForm() {
    this.setState({
      showCreatePassword: false,
      showLoginForm: true,
      showLocale:true,
      showVerificationCode: false,
      showDeliveryMethod: false,
      showcreateSecurityQnA:false,
      showTcModel:false,
      showHide: false,
      title: this.state.admin,
      username: this.state.username
    });
  }
  resendCode(value, deliveryTy) {
    this.setState({
      showResendMessage: value,
      showResendType: deliveryTy
    });
  }

  render() {
    return <div />;
  }
}



// WEBPACK FOOTER //
// ./src/scenes/admin-login/AppService.js